export const PAGE_RENDER_TYPE = Object.freeze({
  PAGE: "PAGE",
  TAB: "TAB",
});

export const SIDEMENU_MODE = Object.freeze({
  SEARCH: "SEARCH",
  MENU: "MENU",
  FAVORITE: "FAVORITE",
});

export const LOCAL_STORAGE_KEYS = Object.freeze({
  ACCESS_TOKEN: import.meta.env.VITE_PROJECT_NAME + "-" + "accessToken",
  REFRESH_TOKEN: import.meta.env.VITE_PROJECT_NAME + "-" + "refreshToken",
  SAVED_LOGIN_ID: import.meta.env.VITE_PROJECT_NAME + "-" + "savedLoginId",
  COMMON_CODES: import.meta.env.VITE_PROJECT_NAME + "-" + "commonCodes",
  IS_TOUCH_SCREEN_DEVICE:
    import.meta.env.VITE_PROJECT_NAME + "-" + "isTouchScreenDevice",
  GRID_PSN: import.meta.env.VITE_PROJECT_NAME + "-" + "gridPsn",
  AZURE_LOGIN: import.meta.env.VITE_PROJECT_NAME + "-" + "azureLogin",
  PATH_NAME: import.meta.env.VITE_PROJECT_NAME + "-" + "pathname",
  SEARCH: import.meta.env.VITE_PROJECT_NAME + "-" + "search",
  MENU_ID: import.meta.env.VITE_PROJECT_NAME + "-" + "menuId",
  SHEET_STYLE: import.meta.env.VITE_PROJECT_NAME + "-" + "sheetStyle",
  BUTTON_STYLE: import.meta.env.VITE_PROJECT_NAME + "-" + "buttonStyle",
  AUTH_LISTS: import.meta.env.VITE_PROJECT_NAME + "-" + "authLists",
  NOTICE_EXCLUDE_LIST:
    import.meta.env.VITE_PROJECT_NAME + "-" + "noticeExcludeList",
});

export const AUTH = Object.freeze(["AUTH_ADMIN"]);
